"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHeader = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var FontAwesomeIcon_1 = require("../FontAwesomeIcon");
var headerSize = {
    "1": "2rem",
    "2": "1.5rem",
    "3": "1.25rem",
    "4": "1.15rem",
    "5": "1rem"
};
var headerWeight = {
    "1": 300,
    "2": 400,
    "3": 400,
    "4": 400,
    "5": 500
};
var headerLineHeight = {
    "1": "2.25rem",
    "2": "1.75rem",
    "3": "1.75rem",
    "4": "1.75rem",
    "5": "1.15rem"
};
var innerFunction = react_1.default.forwardRef(function (_a, ref) {
    var as = _a.as, link = _a.link, size = _a.size, props = __rest(_a, ["as", "link", "size"]);
    var Tag = as || "h1";
    return react_1.default.createElement(Tag, __assign({}, props, { ref: ref }));
});
innerFunction.displayName = "innerFunction";
exports.StyledHeader = styled_components_1.default(innerFunction)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  text-rendering: optimizelegibility;\n  -webkit-font-smoothing: antialiased;\n  font-family: ", ";\n  color: ", ";\n  line-height: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", " {\n    color: inherit;\n    font-size: inherit;\n  }\n"], ["\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  text-rendering: optimizelegibility;\n  -webkit-font-smoothing: antialiased;\n  font-family: ", ";\n  color: ", ";\n  line-height: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n\n  ", " {\n    color: inherit;\n    font-size: inherit;\n  }\n"])), style_utils_1.getFont("heading"), style_utils_1.getColor("gray", 900), function (props) { return headerLineHeight[props.size]; }, function (props) { return headerSize[props.size]; }, function (props) { return headerWeight[props.size]; }, function (_a) {
    var size = _a.size;
    return [2, 3].includes(size) && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      orphans: 3;\n      widows: 3;\n      page-break-after: avoid;\n    "], ["\n      orphans: 3;\n      widows: 3;\n      page-break-after: avoid;\n    "])));
}, function (_a) {
    var size = _a.size;
    return size === 5 && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      text-transform: uppercase;\n    "], ["\n      text-transform: uppercase;\n    "])));
}, function (props) {
    return props.link && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      color: ", ";\n      cursor: pointer;\n\n      &:hover {\n        color: ", ";\n        text-decoration: underline;\n      }\n    "], ["\n      color: ", ";\n      cursor: pointer;\n\n      &:hover {\n        color: ", ";\n        text-decoration: underline;\n      }\n    "])), style_utils_1.colorSelector(props, "primary", 500), style_utils_1.colorSelector(props, "primary", 400));
}, FontAwesomeIcon_1.StyledFontAwesomeIcon);
var Header = react_1.default.forwardRef(function (_a, ref) {
    var as = _a.as, size = _a.size, props = __rest(_a, ["as", "size"]);
    return (react_1.default.createElement(exports.StyledHeader, __assign({}, props, { size: size, forwardedAs: as || "h" + size, ref: ref })));
});
Header.displayName = "Header";
Header.defaultProps = {
    size: 1
};
exports.default = Header;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map